import React from 'react';
import { Link } from 'react-router-dom';

const ViewLink = ({to, children}) => {
    return (
        <Link 
            to={`/location/${to}/forecast`}
            className="view-link text-xs text-custom-light-blue hover:text-custom-light-blue/80 transition-colors cursor-pointer border rounded-lg border-custom-light-blue/30 px-3 py-1 md:hover:bg-custom-light-blue/10 md:hover:text-white"
        >
            {children}
        </Link>
    );
};

export default ViewLink;
